import { Avatar, Menu, MenuItem } from "@mui/material";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LogoutIcon from "@mui/icons-material/Logout";
import DescriptionIcon from "@mui/icons-material/Description";
import EditIcon from "@mui/icons-material/Edit";
import Cookies from "js-cookie";
import { getAdmin } from "../api/requests/Admin";
import toast from "react-hot-toast";

function Header() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [photo, setPhoto] = useState("");
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    Cookies.remove("id");
    Cookies.remove("role");
    Cookies.remove("email");
    Cookies.remove("token");
    Cookies.remove("first_name");
    Cookies.remove("last_name");
    localStorage.removeItem("photo");
    navigate("/loginadmin");
    handleMenuClose();
  };

  useEffect(() => {
    const id = Cookies.get("id");
    const first_name = Cookies.get("first_name");
    const last_name = Cookies.get("last_name");
    const role = Cookies.get("role");
    const photo = localStorage.getItem("photo");
    const token = Cookies.get("token");
    

    // debugger;
    if (id && first_name && last_name && role && token) {
      setName(first_name + " " + last_name);
      setRole(role);
      setPhoto(photo);

      getAdmin(id)
        .then((res) => {
          if (res.success && res.status == 200) {
            setName(res.data.first_name + " " + res.data.last_name);
            setPhoto(res.data.photo);
          } else {
            toast.error(res.error);
          }
        })
        .catch((error) => {
          toast.error(t("500"));
        });
    }
  }, []);

  const handleTerms = () => {
    navigate("/termsadmin");
    handleMenuClose();
  };

  const handleEditData = () => {
    const admin = true;
    navigate("/editpersonaldata", { state: { isAdmin: admin } });
    handleMenuClose();
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="header">
        <div className="headerRight" style={{ float: "right" }}>
          <li className="header-toggle" style={{ height: 0 }}>
            <div
              style={{
                marginRight: 30,
                flexDirection: "column",
                display: "flex",
              }}
            >
              <a className="textHeader">{name}</a>
              <a className="subtextHeader">{role}</a>
            </div>
            <div style={{marginRight:isMobile? 10: 40}}>
              <Avatar
                src={photo}
                sx={{
                  width: 35,
                  height: 35,
                  border: "1px solid #171E24",
                  cursor: "pointer",
                }}
                onClick={handleMenuOpen}
              />
            </div>
          </li>
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        sx={{
          background: "transparent",

          borderColor: "transparent",
          marginTop: "25px",
          width: "254px",
          height: "auto",
        }}
        MenuListProps={{
          style: {
            padding: "8px 0",
          },
        }}
      >
        <MenuItem
          onClick={handleLogout}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px !important",
            fontSize: "14px",
            fontWeight: 500,
            fontFamily: "Montserrat",
            color: "#0F1111",
          }}
        >
          {t("logout")}
          <LogoutIcon
            sx={{ marginLeft: "10px", color: "#0F1111", fontSize: "16px" }}
          />
        </MenuItem>
        <MenuItem
          onClick={handleTerms}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px !important",
            fontSize: "14px",
            fontWeight: 500,
            fontFamily: "Montserrat",
            color: "#0F1111",
          }}
        >
          {t("terms")}
          <DescriptionIcon
            sx={{ marginLeft: "10px", color: "#0F1111", fontSize: "16px" }}
          />
        </MenuItem>
        <MenuItem
          onClick={handleEditData}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "10px !important",
            fontSize: "14px",
            fontWeight: 500,
            fontFamily: "Montserrat",
            color: "#0F1111",
          }}
        >
          {t("editPersonalData")}
          <EditIcon
            sx={{ marginLeft: "10px", color: "#0F1111", fontSize: "16px" }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}

export default Header;
